import React, { Component } from 'react'
import { Container } from 'semantic-ui-react'

/* importing custom components */
import InfoList from './components/InfoList'
import HeaderTitulo from './components/HeaderTitulo'
import HomePage from './components/HomePage'


class App extends Component {


  render() {
    return (
      <div>
        <HeaderTitulo />
        <Container>
          <HomePage />

          <InfoList />
        </Container>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js